var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Divider, Stack, Typography } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FormButton, FormButtonType } from "../../components/FormButton";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { ProgressStepper } from "../../components/ProgressStepper";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { TopBar } from "../../components/TopBar";
import { useAuth } from "../../hooks/useAuth";
import { cancelarPid, cancelarProcesso, obterEtapasProcesso, } from "../../services/andamento.service";
import { obterDadosCondutor } from "../../services/habilitacao.service";
import { FormularioRenach } from "../../components/Habilitacao/FormularioRenach";
import { formatName } from "../../util/formatadores";
export var Progress = function () {
    var navigate = useNavigate();
    var userInfo = useAuth().userInfo;
    var _a = useState(), steps = _a[0], setSteps = _a[1];
    var _b = useState(false), isPid = _b[0], setIsPid = _b[1];
    var _c = useState(), driverData = _c[0], setDriverData = _c[1];
    var _d = useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState(), sucessMessage = _e[0], setSucessMessage = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), cancelModal = _g[0], setCancelModal = _g[1];
    var _h = useState(false), renachModal = _h[0], setRenachModal = _h[1];
    var _j = useState(false), isPayment = _j[0], setIsPayment = _j[1];
    var cancelProcess = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, _a, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setLoading(true);
                    setErrorMessage(undefined);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 7, 8, 9]);
                    if (!(driverData === null || driverData === void 0 ? void 0 : driverData.numeroRenach)) return [3 /*break*/, 6];
                    payload = {
                        numeroRenach: driverData.numeroRenach,
                        consideracao: "cancelamento do processo",
                    };
                    if (!isPid) return [3 /*break*/, 3];
                    return [4 /*yield*/, cancelarPid(payload)];
                case 2:
                    _a = _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, cancelarProcesso(payload)];
                case 4:
                    _a = _e.sent();
                    _e.label = 5;
                case 5:
                    _a;
                    setSucessMessage("O processo foi cancelado com sucesso!");
                    setTimeout(function () {
                        navigate(0);
                    }, 700);
                    _e.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_1 = _e.sent();
                    setErrorMessage((_d = (_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.MensagemRetorno) !== null && _d !== void 0 ? _d : "Erro ao cancelar processos");
                    console.error(error_1);
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    setCancelModal(false);
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchDriverData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, 4, 5]);
                        if (!userInfo) return [3 /*break*/, 2];
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _d.sent();
                        setDriverData(response);
                        setIsPid(response.descricaoTipoProcesso === "Permissão Internacional");
                        fetchSteps(response.numeroRenach, response.descricaoTipoProcesso);
                        _d.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        error_2 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao recuperar dados do condutor.");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchSteps = function (numeroRenach, descricaoTipoProcesso) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, stepAtivo, error_3;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, 3, 4]);
                        payload = {
                            numeroRenach: numeroRenach,
                            processoPid: descricaoTipoProcesso === "Permissão Internacional" ? "1" : "0",
                        };
                        return [4 /*yield*/, obterEtapasProcesso(payload)];
                    case 1:
                        response = _e.sent();
                        stepAtivo = response.find(function (step) { return step.etapaAtual; });
                        setIsPayment((_a = stepAtivo === null || stepAtivo === void 0 ? void 0 : stepAtivo.geraPagamento) !== null && _a !== void 0 ? _a : false);
                        setSteps(response);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _e.sent();
                        setErrorMessage((_d = (_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.MensagemRetorno) !== null && _d !== void 0 ? _d : "Erro ao recuperar etapas do processo.");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDriverData();
    }, [userInfo]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(TopBar, { titulo: "Acompanhamento de Solicita\u00E7\u00E3o", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs(Typography, __assign({ variant: "h6" }, { children: ["Processo em Aberto - ", formatName(driverData === null || driverData === void 0 ? void 0 : driverData.descricaoTipoProcesso)] })), _jsxs(Typography, __assign({ variant: "h6", color: "textSecondary" }, { children: ["Renach: ", driverData === null || driverData === void 0 ? void 0 : driverData.numeroRenach] }))] }), _jsxs(Stack, __assign({ px: '1rem' }, { children: [steps && _jsx(ProgressStepper, { steps: steps }), _jsxs(Stack, __assign({ direction: { md: "row-reverse", xs: "column" }, justifyContent: "space-between", gap: "2rem" }, { children: [_jsx(FormButton, { type: FormButtonType.PRIMARY, title: "D\u00E9bitos Pendentes", onClick: function () { return navigate("/habilitacao/emitir-taxas"); }, isDisabled: !isPayment }), (driverData === null || driverData === void 0 ? void 0 : driverData.descricaoTipoProcesso) !== "Permissão Internacional" && (_jsx(FormButton, { type: FormButtonType.GREEN_PRIMARY, title: "Solicitar Formul\u00E1rio Renach", onClick: function () { return setRenachModal(true); } })), _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Cancelar Solicita\u00E7\u00E3o", onClick: function () { return setCancelModal(true); } })] }))] })), _jsx(Divider, { sx: { marginTop: "1rem" } }), _jsxs(ContainerLayout, { children: [_jsx(Modal, { open: cancelModal, onClose: function () { return setCancelModal(false); }, title: "Cancelar Solicita\u00E7\u00E3o", subTitle: "Tem certeza que voc\u00EA deseja cancelar o processo em aberto?", buttons: [
                            _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Confirmar cancelamento", onClick: cancelProcess }, 0),
                            _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "Voltar", onClick: function () { return setCancelModal(false); } }, 1),
                        ] }), renachModal && driverData && _jsx(FormularioRenach, { isOpen: renachModal, close: function () { return setRenachModal(false); }, renach: driverData.numeroRenach }), errorMessage && (_jsx(SnackbarFeedback, { isOpen: !!errorMessage, type: "error", message: errorMessage })), sucessMessage && (_jsx(SnackbarFeedback, { isOpen: true, type: "success", message: sucessMessage }))] })] }));
};
